<template>
  <section
    class="roadmap section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="roadmap-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <c-timeline>
          <c-timeline-item>{{ $t(`${type}.process.one`) }}</c-timeline-item>
          <c-timeline-item>{{ $t(`${type}.process.two`) }}</c-timeline-item>
          <c-timeline-item>{{ $t(`${type}.process.three`) }}</c-timeline-item>
          <c-timeline-item>{{ $t(`${type}.process.four`) }}</c-timeline-item>
          <c-timeline-item>{{ $t(`${type}.process.five`) }}</c-timeline-item>
        </c-timeline>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CTimeline from "@/components/elements/Timeline.vue";
import CTimelineItem from "@/components/elements/TimelineItem.vue";

export default {
  name: "CRoadmap",
  components: {
    CSectionHeader,
    CTimeline,
    CTimelineItem,
  },
  props: {
    type: String,
  },
  mixins: [SectionProps],
  computed: {
    sectionHeader() {
      return {
        title: this.$i18n.t(`${this.type}.process.title`),
      };
    },
  },
};
</script>
